import React from 'react';
import InstagramPostItem from './InstagramPostItem';

function InstagramPostGrid({ posts, onPostSelect }) {
  return (
    <div className="grid grid-cols-3 gap-0 bg-white">
      {posts.map((post) => {
        if (!post.mediaUrl && !post.name && !post.date && !post.postType) return null;
        
        return (
          <InstagramPostItem 
            key={post.id} 
            post={post} 
            onClick={onPostSelect} 
          />
        );
      })}
    </div>
  );
}

export default InstagramPostGrid;
